/**
 * ThemedIndicatorLight.jsx — Issue #312.
 *
 * A small terminal-style "LED" that softly glows when `on` is true and
 * sits dim/off when false. The tint is bound to the active theme's
 * accent token (`--fissal`) so it picks up whichever palette the user
 * has selected without per-call wiring.
 *
 * Use cases:
 *   • Dashboard background overridden vs. theme default (#312)
 *   • Future: custom-theme-applied, sync-relay-online, ai-busy, etc.
 *
 * Props:
 *   - on: boolean (required) — drives the glow.
 *   - tooltip?: string — optional hover description, shown via the
 *       shared CrtTooltip primitive (#263).
 *   - label?: string — optional aria label; defaults to "indicator".
 */
import { Show } from 'solid-js';
import CrtTooltip from './CrtTooltip.jsx';
import './ThemedIndicatorLight.css';

export default function ThemedIndicatorLight(props) {
  const dot = (
    <span
      class="v2-themed-led"
      classList={{ 'is-on': !!props.on }}
      aria-label={props.label || 'indicator'}
      aria-pressed={!!props.on}
      role="status"
    >
      <span class="v2-themed-led__core" aria-hidden="true" />
      <span class="v2-themed-led__halo" aria-hidden="true" />
    </span>
  );
  return (
    <Show when={props.tooltip} fallback={dot}>
      <CrtTooltip text={props.tooltip}>{dot}</CrtTooltip>
    </Show>
  );
}
